module.exports = __webpack_public_path__ + "img/co2.a7a61e2f.svg";